// 合同管理页面路由
const HtglList = () => import('@/views/htgl/index.vue');
const HtglMltjList = () => import('@/views/htgl/mltj/index.vue');
const GrossProfitForecast = () => import('@/views/htgl/mlForecast/index.vue');
const XmycList = () => import('@/views/xmyc/index.vue');
const SalesPerformance = () => import('@/views/htgl/salesPerformance/index.vue');
const SalesAssessmentThreshold = () => import('@/views/htgl/salesAssessmentThreshold/index.vue');
const SalesQuarterlyAssessment = () => import('@/views/htgl/salesQuarterlyAssessment/index.vue');
const DataAnalysis = () => import('@/views/htgl/dataAnalysis/index.vue');
const HtbgtzList = () => import('@/views/htgl/htbgtz.vue');
const ExecutionIncomeSummary = () => import('@/views/htgl/executionIncomeSummary/index.vue');
const HtAnnualRepaymentForecast = () =>
  import('@/views/htinfo/htAnnualRepaymentForecast/htAnnualRepaymentForecast.vue');
const HtAnnualRepaymentForecastStatistic = () =>
  import('@/views/htinfo/htAnnualRepaymentForecastStatistic/index.vue');
const HtInvoice = () => import('@/views/htinfo/htInvoice/htInvoice.vue');
const HtRepaymentPlan = () => import('@/views/htinfo/htRepaymentPlan/htRepaymentPlan.vue');
const HtRepaymentPlanQuery = () => import('@/views/htinfo/htRepaymentPlanQuery/index.vue');
const HtRepaymentPlanMonth = () =>
  import('@/views/htinfo/htRepaymentPlanMonth/htRepaymentPlanMonth.vue');
const HtRepaymentPlanMonthStatistic = () =>
  import('@/views/htinfo/htRepaymentPlanMonthStatistic/index.vue');
const HtCurrentQuarterRepaymentStatistic = () =>
  import('@/views/htinfo/htCurrentQuarterRepaymentStatistic/index.vue');
const HtRepaymentRecordStatistic = () =>
  import('@/views/htinfo/htRepaymentRecordStatistic/index.vue');
const MonthlyRepaymentRegister = () => import('@/views/htinfo/monthlyRepaymentRegister/index.vue');
const HtRepaymentRecord = () => import('@/views/htinfo/htRepaymentRecord/htRepaymentRecord.vue');
const ContractStatistic = () => import('@/views/htinfo/statistic/index.vue');
const HistoricalQuarterRepaymentPlan = () =>
  import('@/views/htinfo/historicalQuarterRepaymentPlan/index.vue');
const HtAnnualQuarterRepaymentPlanStatistic = () =>
  import('@/views/htinfo/annualQuarterRepaymentPlanStatistic/index.vue');

export default [
  {
    path: '/htgl',
    name: 'htgl',
    meta: {
      title: '合同管理',
      icon: 'el-icon-document',
      noCache: false,
      affix: true
    },
    component: HtglList
  },
  {
    path: '/htgl/mltj',
    name: 'htglMltj',
    meta: {
      title: '毛利统计',
      icon: 'el-icon-pie-chart'
    },
    component: HtglMltjList
  },
  {
    path: '/htgl/gross-forecast',
    name: 'htglGrossForecast',
    meta: {
      title: '毛利预测表',
      icon: 'el-icon-s-data'
    },
    component: GrossProfitForecast
  },
  {
    path: '/xmyc',
    name: 'xmyc',
    meta: {
      title: '项目预测',
      icon: 'el-icon-s-data',
      noCache: false,
      affix: true
    },
    component: XmycList
  },
  {
    path: '/salesPerformance',
    name: 'salesPerformance',
    component: SalesPerformance,
    meta: {
      title: '销售人员业绩表',
      icon: 'el-icon-user'
    }
  },
  {
    path: '/htgl/salesAssessmentThreshold',
    name: 'salesAssessmentThreshold',
    component: SalesAssessmentThreshold,
    meta: {
      title: '考核门槛设置',
      icon: 'el-icon-s-finance',
      path: '合同管理',
      noCache: true,
      affix: true
    }
  },
  {
    path: '/htgl/salesQuarterlyAssessment',
    name: 'salesQuarterlyAssessment',
    component: SalesQuarterlyAssessment,
    meta: {
      title: '绩效考核',
      icon: 'el-icon-date',
      path: '合同管理',
      noCache: true,
      affix: true
    }
  },
  {
    path: '/dataAnalysis',
    name: 'dataAnalysis',
    component: DataAnalysis,
    meta: {
      title: '数据分析',
      icon: 'el-icon-user'
    }
  },
  {
    path: '/htgl/executionIncomeSummary',
    name: 'executionIncomeSummary',
    component: ExecutionIncomeSummary,
    meta: {
      title: '部门执行收入统计',
      icon: 'el-icon-data-analysis',
      path: '合同管理',
      noCache: true,
      affix: true
    }
  },
  {
    path: '/htgl/htbgtz',
    name: 'htbgtz',
    component: HtbgtzList,
    meta: {
      title: '合同变更台账',
      icon: 'el-icon-document-copy'
    }
  },
  {
    path: '/htinfo/annual-repayment-forecast',
    name: 'htAnnualRepaymentForecast',
    component: HtAnnualRepaymentForecast,
    meta: {
      title: '年度回款预测',
      icon: 'el-icon-data-analysis',
      path: '合同信息',
      noCache: true,
      affix: true
    }
  },
  {
    path: '/htinfo/annual-repayment-forecast-statistic',
    name: 'htAnnualRepaymentForecastStatistic',
    component: HtAnnualRepaymentForecastStatistic,
    meta: {
      title: '年度预测统计',
      icon: 'el-icon-s-data',
      path: '合同信息',
      noCache: true,
      affix: true
    }
  },
  {
    path: '/htinfo/invoice',
    name: 'htInvoice',
    component: HtInvoice,
    meta: {
      title: '开票记录',
      icon: 'el-icon-tickets',
      path: '合同信息',
      noCache: true,
      affix: true
    }
  },
  {
    path: '/htinfo/repayment-plan',
    name: 'htRepaymentPlan',
    component: HtRepaymentPlan,
    meta: {
      title: '回款计划确认',
      icon: 'el-icon-date',
      path: '合同信息',
      noCache: true,
      affix: true
    }
  },
  {
    path: '/htinfo/repayment-plan-query',
    name: 'htRepaymentPlanQuery',
    component: HtRepaymentPlanQuery,
    meta: {
      title: '月度回款计划统计',
      icon: 'el-icon-search',
      path: '合同信息',
      noCache: true,
      affix: true
    }
  },
  {
    path: '/htinfo/repayment-plan-month',
    name: 'htRepaymentPlanMonth',
    component: HtRepaymentPlanMonth,
    meta: {
      title: '月度回款计划统计',
      icon: 'el-icon-date',
      path: '合同信息',
      noCache: true,
      affix: true
    }
  },
  {
    path: '/htinfo/repayment-plan-month-statistic',
    name: 'htRepaymentPlanMonthStatistic',
    component: HtRepaymentPlanMonthStatistic,
    meta: {
      title: '月度回款计划统计',
      icon: 'el-icon-s-data',
      path: '合同信息',
      noCache: true,
      affix: true
    }
  },
  {
    path: '/htinfo/current-quarter-repayment-statistic',
    name: 'htCurrentQuarterRepaymentStatistic',
    component: HtCurrentQuarterRepaymentStatistic,
    meta: {
      title: '当前季度回款统计',
      icon: 'el-icon-s-data',
      path: '合同信息',
      noCache: true,
      affix: true
    }
  },
  {
    path: '/htinfo/repayment-record-statistic',
    name: 'htRepaymentRecordStatistic',
    component: HtRepaymentRecordStatistic,
    meta: {
      title: '回款统计',
      icon: 'el-icon-s-data',
      path: '合同信息',
      noCache: true,
      affix: true
    }
  },
  {
    path: '/htinfo/monthly-repayment-register',
    name: 'monthlyRepaymentRegister',
    component: MonthlyRepaymentRegister,
    meta: {
      title: '月度回款计划登记',
      icon: 'el-icon-coin',
      path: '合同信息',
      noCache: true,
      affix: true
    }
  },
  {
    path: '/htinfo/repayment-record',
    name: 'htRepaymentRecord',
    component: HtRepaymentRecord,
    meta: {
      title: '回款登记',
      icon: 'el-icon-coin',
      path: '合同信息',
      noCache: true,
      affix: true
    }
  },
  {
    path: '/htinfo/statistic',
    name: 'contractStatistic',
    component: ContractStatistic,
    meta: {
      title: '合同执行汇总',
      icon: 'el-icon-s-data',
      path: '合同信息',
      noCache: true,
      affix: true
    }
  },
  {
    path: '/htinfo/historical-quarter-repayment-plan',
    name: 'historicalQuarterRepaymentPlan',
    component: HistoricalQuarterRepaymentPlan,
    meta: {
      title: '历史合同季度回款计划',
      icon: 'el-icon-date',
      path: '合同信息',
      noCache: true,
      affix: true
    }
  },
  {
    path: '/htinfo/annual-quarter-repayment-plan-statistic',
    name: 'htAnnualQuarterRepaymentPlanStatistic',
    component: HtAnnualQuarterRepaymentPlanStatistic,
    meta: {
      title: '年度回款计划统计',
      icon: 'el-icon-s-data',
      path: '合同信息',
      noCache: true,
      affix: true
    }
  }
];
